import { forwardRef, type InputHTMLAttributes, memo, ReactNode, Ref } from 'react';
import { Center } from '../Center';
import { Row } from '../Row';
import './Style.scss';

interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  PrefixComponent?: ReactNode;
}

const Component = (
  { PrefixComponent, placeholder, ...rest }: IInputProps,
  ref: Ref<HTMLInputElement>,
) => {
  return (
    <Row alignItems="center" className="input-ui" gap={8}>
      {PrefixComponent && (
        <Center height={24} width={24}>
          {PrefixComponent}
        </Center>
      )}
      <input {...rest} ref={ref} placeholder={placeholder} />
    </Row>
  );
};

export const Input = memo(forwardRef(Component)) as <T = HTMLInputElement>(
  props: IInputProps & { ref?: Ref<T> },
) => ReturnType<typeof Component>;
